import translator from "@/translator";
import React from "react";
import { Form } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import ServiceForm from "./components/ServiceForm";
import useServiceSubmit from "@/note_office/views/services/hooks/useServiceSubmit";

const t = translator("note_office.views.services.new_view.");

const NewView = ({ servicesData }) => {
  const { services_url, create_service_url, duration_options, currency_options, format_options } =
    servicesData || {};

  const [form] = Form.useForm();

  const { isSubmitting, submitService } = useServiceSubmit({
    form,
    url: create_service_url,
    method: "post",
    t,
    onSuccessRedirect: () => services_url,
  });

  const handleFinish = (values) => submitService(values);

  const handleCancel = () => {
    window.location.href = services_url;
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton link={services_url} text={t("title")} />

      <ServiceForm
        form={form}
        initialValues={{
          name: "",
          duration: 300,
          price_min: "",
          price_max: "",
          description: "",
          format: "offline",
          currency: "EUR",
          active: true,
          meeting_url: "",
          address: "",
        }}
        duration_options={duration_options}
        currency_options={currency_options}
        format_options={format_options}
        loading={isSubmitting}
        onFinish={handleFinish}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default NewView;
